module.exports = __webpack_public_path__ + "img/Forma 1.aea81014.svg";